"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _TwelveColumnGrid = _interopRequireDefault(require("../../components/Grid/TwelveColumnGrid/TwelveColumnGrid"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["children"],
  _excluded2 = ["variant", "children"];
var _templateObject, _templateObject2;
var StyledTwoColumnLayout = (0, _styledComponents.default)(_TwelveColumnGrid.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  \n"])));
var StyledColumn = (0, _styledComponents.default)(_TwelveColumnGrid.default.Item)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  /* background-color: ", "; */\n"])), function (props) {
  return props.columnColor ? props.columnColor : 'var(--bf-core-dark-teal)';
});
var columnWidthSpecs = {
  SixSixRatio: {
    colOneWidth: 6,
    colTwoWidth: 6
  },
  SevenTwoRatio: {
    colOneWidth: 7,
    colTwoWidth: 2
  },
  SevenFourRatio: {
    colOneWidth: 7,
    colTwoWidth: 4
  },
  SevenFiveRatio: {
    colOneWidth: 7,
    colTwoWidth: 5
  },
  EightFourRatio: {
    colOneWidth: 8,
    colTwoWidth: 4
  },
  NineThreeRatio: {
    colOneWidth: 9,
    colTwoWidth: 3
  },
  TwelveTwelveRatio: {
    colOneWidth: 12,
    colTwoWidth: 12
  },
  FourFourRatio: {
    colOneWidth: 4,
    colTwoWidth: 4
  }
};
function SingleColumn(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var storeVar = props.variant ? columnWidthSpecs[props.variant] : columnWidthSpecs['TwelveTwelveRatio'];
  return _react.default.createElement(StyledColumn, Object.assign({
    xs: 12,
    sm: 12,
    md: storeVar["".concat(props.columnNumber, "Width")],
    lg: storeVar["".concat(props.columnNumber, "Width")],
    xl: storeVar["".concat(props.columnNumber, "Width")]
  }, props), children);
}
function TwoColumnLayout(_ref2) {
  var variant = _ref2.variant,
    children = _ref2.children,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  var storeVar = variant ? columnWidthSpecs[variant] : columnWidthSpecs['TwelveTwelveRatio'];
  return _react.default.createElement(StyledTwoColumnLayout, Object.assign({
    justifyContent: storeVar.colOneWidth + storeVar.colTwoWidth < 12 ? 'space-between' : 'flex-start'
  }, props), children);
}
;
TwoColumnLayout.Column = SingleColumn;
var _default = TwoColumnLayout;
exports.default = _default;